/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import Image from '../partials/Image';
import Link from '../partials/Link';

import styles from '../../../styles/blocks/partners.module.scss';

const propTypes = {
    title: PropTypes.string,
    partners: AppPropTypes.partners,
    main: PropTypes.bool,
    small: PropTypes.bool,
    isContainer: PropTypes.bool,
    className: PropTypes.string,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    title: null,
    partners: null,
    main: false,
    small: false,
    isContainer: false,
    className: null,
    containerClassName: null,
};

const PartnersBlock = ({
    title,
    partners,
    main,
    small,
    isContainer,
    className,
    containerClassName,
}) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
                [styles.main]: main,
            },
        ])}
    >
        <div
            className={classNames([
                'blockPartners',
                styles.inner,
                {
                    [styles.isContainer]: small || isContainer,
                    [containerClassName]: (small || isContainer) && containerClassName !== null,
                },
            ])}
        >
            {title !== null ? <div className={styles.title}>{title}</div> : null}
            <div className={styles.partners}>
                {(partners || []).map(
                    (
                        { name = null, image = null, url = null, description = null },
                        partnerIndex,
                    ) => (
                        <div
                            className={classNames([
                                styles.partnerContainer,
                                {
                                    [styles.wide]: description !== null,
                                },
                            ])}
                            key={`${name}-${partnerIndex + 1}`}
                        >
                            <div className={styles.partnerContent}>
                                <Link
                                    key={`partner-${partnerIndex + 1}`}
                                    href={url}
                                    external
                                    className={classNames([
                                        styles.partner,
                                        {
                                            [styles.hasImage]: image !== null,
                                            [styles.hasDescription]: description !== null,
                                        },
                                    ])}
                                >
                                    <div className={classNames([styles.identity])}>
                                        {name !== null ? (
                                            <div className={styles.name}>{name}</div>
                                        ) : null}
                                        {image !== null ? (
                                            <Image
                                                className={styles.image}
                                                media={image}
                                                alt={name}
                                                fit
                                                contain
                                            />
                                        ) : null}
                                    </div>
                                    {description !== null ? (
                                        <p className={styles.description}>{description}</p>
                                    ) : null}
                                </Link>
                            </div>
                        </div>
                    ),
                )}
            </div>
        </div>
    </div>
);

PartnersBlock.propTypes = propTypes;
PartnersBlock.defaultProps = defaultProps;

export default PartnersBlock;
